
import { Star } from 'lucide-react';

interface PatientTestimonialCardProps {
  name: string;
  content: string;
  rating: number;
  image?: string;
}

export const PatientTestimonialCard = ({ 
  name, 
  content, 
  rating,
  image 
}: PatientTestimonialCardProps) => {
  return (
    <div className="bg-[#32303A] p-6 rounded-xl shadow-lg hover:-translate-y-1 transition-transform duration-300">
      <div className="flex space-x-1 mb-4">
        {[...Array(5)].map((_, i) => (
          <Star
            key={i}
            size={18}
            className={`${
              i < rating ? 'text-yellow-400 fill-yellow-400' : 'text-gray-500'
            }`}
          />
        ))}
      </div>
      
      <p className="mb-6 text-white/80 italic">{content}</p>
      
      <div className="flex items-center">
        {image && (
          <img
            src={image}
            alt={name}
            className="w-12 h-12 rounded-full object-cover mr-4"
          />
        )}
        <h4 className="font-medium text-white">{name}</h4>
      </div>
    </div>
  );
};
